import { render, staticRenderFns } from "./EditarConvocatoriaDialogComponent.vue?vue&type=template&id=bc685626"
import script from "./EditarConvocatoriaDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarConvocatoriaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports